import ItemUtility from '../../utilities/ItemUtility.js';
import ServiceFetch from '../../utilities/ServiceFetch.js';
/**
 * This class is used for fetching assembly services data.
 */
export default class DexfAssemblyServicesService {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.endpoint Endpoint.
     * @param options.dexfApiKey DEXF Api key.
     */
    constructor(options) {
        this.maxItemsPerRequest = 50;
        this.endpoint = options.endpoint;
        this.dexfApiKey = options.dexfApiKey;
    }
    /**
     * Fetches assembly services data.
     *
     * @param zipCode Zip Code.
     * @param items Item.
     * @returns Promise.
     */
    async getAssemblyServices(zipCode, items) {
        const batchRequests = ItemUtility.getItemSets(items, this.maxItemsPerRequest);
        const options = {
            credentials: 'same-origin',
            headers: {
                'dexf-api-key': this.dexfApiKey
            }
        };
        const promises = batchRequests.map((set) => {
            const itemId = ItemUtility.getItemsString(set);
            const url = `${this.endpoint.replace('{zipCode}', encodeURIComponent(zipCode.replace(/ /g, '')))}?filter.itemId=${itemId}`;
            return ServiceFetch.json(url, options);
        });
        const responses = await Promise.all(promises);
        return this.transformResponse(responses);
    }
    /**
     * Transforms the response and returns assembly services items.
     *
     * @param responses Array of responses.
     * @returns Valid items.
     */
    transformResponse(responses) {
        const { valid, basePrice, reason } = responses[0].data;
        const assemblyServicesData = {
            valid: valid,
            ...(basePrice && { basePrice }),
            ...(reason && { reason })
        };
        const assemblyItems = [];
        for (const response of responses) {
            const { items } = response.data;
            if (items) {
                for (const item of items) {
                    assemblyItems.push(item);
                }
            }
        }
        if (assemblyItems.length > 0) {
            assemblyServicesData.items = assemblyItems;
        }
        return assemblyServicesData;
    }
}
//# sourceMappingURL=DexfAssemblyServicesService.js.map